var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bullet-list-item__icon",on:{"click":_vm.changeState}},[(_vm.type === 'task')?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):[_vm._v(_vm._s(_vm.icon))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }